export const DefaultTableColumns = {
  NAME: 'NAME',
  GOAL: 'GOAL',
  CLOSED: 'CLOSED',
  ATTAINMENT: 'ATTAINMENT',
  FORECAST: 'FORECAST',
  COVERAGE: 'COVERAGE',
  COVERAGE_RATIO: 'COVERAGE_RATIO'
};
export const DEFAULT_TABLE_COLUMNS_TO_OVERVIEW_ROW_PROPERTIES_MAP = {
  [DefaultTableColumns.NAME]: 'name',
  [DefaultTableColumns.GOAL]: 'goal',
  [DefaultTableColumns.CLOSED]: 'closed',
  [DefaultTableColumns.ATTAINMENT]: 'attainment',
  [DefaultTableColumns.FORECAST]: 'forecastValue',
  [DefaultTableColumns.COVERAGE]: 'totalForecastedAmount',
  [DefaultTableColumns.COVERAGE_RATIO]: 'coverage'
};
export const EMPTY_FIELD_VALUE = '—';
export const DEAL_GROUPING_SUFFIX = '-deal-grouping';